/**
 * Wording and small helpers for discussions (projects/discussions). Kept
 * out of the component files so react-refresh stays happy and the list,
 * the thread and the tests agree.
 */

/** "2 of 3 answered" while a panel's answers are closed; "answers open" after. */
export function panelSummary(discussion) {
  if (!discussion?.is_panel) return "";
  if (discussion.answers_open) return "answers open";
  const panelists = discussion.panelists || [];
  const answered = panelists.filter((p) => p.answered).length;
  return `${answered} of ${panelists.length} answered`;
}

const MAX_TASK_TITLE = 120;

/** A post's first line, without markdown markers — a task's title. */
export function taskTitleFrom(body) {
  const line =
    (body || "")
      .split("\n")
      .map((l) => l.replace(/^\s*(?:#{1,6}\s|[-*+]\s|>\s?|\d+\.\s)/, "").trim())
      .find(Boolean) || "";
  return line.length > MAX_TASK_TITLE
    ? `${line.slice(0, MAX_TASK_TITLE - 1)}…`
    : line;
}

/** The post, then a link back to where it was said. */
export function taskDescriptionFrom(
  body,
  discussion,
  origin = window.location.origin,
) {
  return `${(body || "").trim()}\n\nFrom the discussion “${discussion.title}”: ${origin}/discussions/${discussion.id}`;
}

/** Add "@name " to a draft, with a space before it when needed. */
export function withMention(draft, name) {
  const mention = `@${name} `;
  if (!draft) return mention;
  return /\s$/.test(draft) ? `${draft}${mention}` : `${draft} ${mention}`;
}
